import React from 'react'

// importing the svg's of buttons
import home from '../../img/home.svg'
import readingList from '../../img/readinglist.svg'
import listings from '../../img/listings.svg'
import podcasts from '../../img/podcasts.svg'
import videos from '../../img/videos.svg'
import tags from '../../img/tags.svg'
import codeofconduct from '../../img/codeofconduct.svg'
import faq from '../../img/faq.svg'
import devshop from '../../img/devshop.svg'
import about from '../../img/about.svg'
import privacypolicy from '../../img/privacypolicy.svg'
import termsofuse from '../../img/termsofuse.svg'
import contact from '../../img/contact.svg'
import customizetags from '../../img/customizetags.svg'

// importing svg's of social networks
import twitter from '../../img/twitter.svg'
import facebook from '../../img/facebook.svg'
import github from '../../img/github.svg'
import instagram from '../../img/instagram.svg'
import twitch  from '../../img/twitch.svg'

//import img of devshop
import devshopimg from '../../img/devshop.jpg'

export default function AsideLeftHome() {
    return (
        <aside className="d-none d-md-block col-sm-4 col-xl-3">
        <nav className="d-flex icons section-list collapse" id="section-list" aria-expanded="false">
            <a href="#" className="item-list">
                <span><img src={home} alt=""/></span>Home</a>
            <a href="#" className="item-list">
                <span><img src={readingList} alt=""/></span>Reading List</a>
            <a href="#" className="item-list">
                <span><img src={listings} alt=""/></span>Listings</a>
            <a href="#" className="item-list">
                <span><img src={podcasts} alt=""/></span>Podcasts</a>
            <a href="#" className="item-list">
                <span className="crayons-icon crayons-icon--default"><img src={videos}
                        alt=""/></span>Videos</a>
            <a href="#" className="item-list">
                <span><img src={tags} alt=""/></span>Tags</a>
            <a href="#" className="item-list">
                <span><img src={codeofconduct} alt=""/></span>Code of Coduct</a>
            <a href="#" className="item-list">
                <span><img src={faq} alt=""/></span>FAQ</a>
            <a href="#" className="item-list">
                <span><img src={devshop} alt=""/></span>DEV Shop</a>
            <a href="#" className="item-list">
                <span><img src={about} alt=""/></span>About</a>
            <a href="#" className="item-list">
                <span><img src={privacypolicy} alt=""/></span>Privacy Policy</a>
            <a href="#" className="item-list">
                <span><img src={termsofuse} alt=""/></span>Terms of use</a>
            <a href="#" className="item-list">
                <span><img src={contact} alt=""/></span>Contact</a>
            <div className="mt-5 social-icons mb-5"> 
                    <a href="https://twitter.com/thepracticaldev" target="_blank"
                        className="" rel="noopener">
                        <img src={twitter} alt="twitter"/>
                    </a>
                    <a href="https://facebook.com/thepracticaldev" target="_blank">
                        <img src={facebook} alt="facebook"/>
                    </a>
                    <a href="https://github.com/thepracticaldev" target="_blank">
                        <img src={github} alt="github"/>
                    </a>
                    <a href="https://instagram.com/thepracticaldev" target="_blank"
                        className="crayons-link crayons-link--secondary mx-2" rel="noopener">
                        <img src={instagram} alt="instagram"/>
                    </a>
                    <a href="https://twitch.com/thepracticaldev" target="_blank"
                        className="crayons-link crayons-link--secondary mx-2" rel="noopener">
                        <img src={twitch} alt="twitch"/>
    
                    </a>
                </div>	
        </nav>
        <div className="view-more-sections">
            <button data-toggle="collapse" data-target="#section-list">More...</button>
        </div>
        <div className="mt-3 tags">
            <div className="d-flex tag-header">
                <h5>My Tags</h5>
               <img src={customizetags} alt="#"/>
            </div>
            <nav className="d-flex icons section-list">
              <a href="#" className="item-list">#javascript</a>
              <a href="#" className="item-list">#css</a>
              <a href="#" className="item-list">#dotnet</a>
              <a href="#" className="item-list">#npm</a>

             </nav>
          </div>
        
        <div className="a-l-card mt-5">
            <img className="ad-img-left" src={devshopimg} alt="aside-ad"/>
            <p className="a-l-txt-color">Do you have your <br/>sticker pack yet?</p>
        </div>
    </aside>
    )
}
